import React from 'react';
import { useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { deleteHostAction } from '../../store/thunks/HostActions';
import { deleteDriverAction } from '../../store/thunks/driverActions';

const ActionComponent = ({ link, id, role }) => {
  const dispatch = useDispatch();

  const handleDelete = () => {
    if (window.confirm("Are you sure?")) {
      if (link === "host") dispatch(deleteHostAction(id));
      if (link === "driver") dispatch(deleteDriverAction(id));
    }
  };

  return (
    <>
      <NavLink
        to={`/${link}List/${id}`}
        className="bg-viewBlue p-1 px-4 rounded-[21px] text-white"
      >
        View
      </NavLink>

      <NavLink
        to={`/${link}List/${id}`}
        className="bg-editGreen p-1 px-4 rounded-[21px] text-white"
      >
        Edit
      </NavLink>

      {role !== "support" && (
        <button
          onClick={handleDelete}
          className="bg-deleteRed p-1 px-4 rounded-[21px] text-white"
        >
          Delete
        </button>
      )}
    </>
  );
};

export default ActionComponent;
